import * as actions from '../actions';
import initialState from '../initialState';
import * as c from '../appConstants';

const calculator = (state = initialState, action) => {
  switch (action.type) {
    case actions.CALCULATE_SAVINGS:
      const { price_per_pack, cigarettes_per_day } = action.calculatorFormData;
      const cigarettesSmokedPerYear =
        cigarettes_per_day * c.NUMBER_OF_DAYS_IN_A_YEAR;
      const cigarettePacksSmokedPerYear =
        cigarettesSmokedPerYear / c.DEFAULT_CIGS_IN_A_PACK;
      const totalSpendingsOnCigarettes =
        cigarettePacksSmokedPerYear * price_per_pack;
      const totalSpendingsOnJuul =
        cigarettePacksSmokedPerYear *
        (1 - state.membershipDiscountRate) *
        state.podPackPrice /
        c.NUMBER_OF_PODS_PER_PACK;
      const totalSavings = totalSpendingsOnCigarettes - totalSpendingsOnJuul;
      return {
        ...state,
        annualAmountSavings: totalSavings > 0 ? totalSavings : 0,
      };
    default:
      return state;
  }
};

export default calculator;



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/reducers/calculator.js